var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apiMarket"},[_c('h1',[_vm._v("API分类")]),_c('div',{staticClass:"flexBlock"},_vm._l((_vm.list),function(item){return _c('ApiBlock',{key:item.id,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }